import { productToGA4Item } from '@lib/analytics/items';
import type { GA4Item } from '@lib/analytics/types';
import type { HttpTypes } from '@medusajs/types';
import type { ProductCardVM } from 'types/view-models';
import { toProductCardVM } from './to-product-card-vm';

type ListingOpts = {
  listId?: string;
  listName?: string;
};

export function toListingVMs(
  products: HttpTypes.StoreProduct[],
  opts?: ListingOpts,
): { cards: ProductCardVM[]; ga4Items: GA4Item[] } {
  return {
    cards: products.map(toProductCardVM),
    ga4Items: products.map((p, i) =>
      productToGA4Item(p, {
        index: i,
        listId: opts?.listId,
        listName: opts?.listName,
      }),
    ),
  };
}
